
import { requireAuth } from './auth';
const baseURL = process.env.VUE_APP_API_BASE_URL;

export async function patchCollectVoice(voiceId) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/voices/CollectVoice`);
    url.searchParams.append('voiceId', voiceId);
    try {
        const response = await fetch(url, {
            method: "PATCH",
            headers: {
                // 'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
        });
        console.log(response);
        const data = await response.json();
        console.log(data)
        return data;
    } catch (error) {
        console.error('patchCollectVoice failed:', error);
        throw error;
    }
}
export async function deleteCollectVoice(voiceId) {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/voices/DisCollectVoice`);
    url.searchParams.append('voiceId', voiceId);
    try {
        const response = await fetch(url, {
            method: "PATCH",
            headers: {
                // 'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('deleteCollectVoice failed:', error);
        throw error;
    }
}
export async function getCollectVoiceIds() {
    if (!await requireAuth()) { return }
    const authToken = localStorage.getItem('auth_token')
    const url = new URL(`${baseURL}/voices/SearchCollectedVoice`);
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                // 'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            },
        });
        const data = await response.json();
        const items = Array.isArray(data) ? data : [];
        const ids = [...new Set(items.map(i => i.voice_id).filter(Boolean))];
        console.log(ids)
        return ids;
    } catch (error) {
        console.error('getCollectVoiceIds failed:', error);
        throw error;
    }
}